export default __webpack_public_path__ + "static/media/34309_18-58.118d7c1b.jpg";